import styles from '../../../pages/LeadCapture/LicenseManager/LicenseManager.module.css'

const LicenseItem = ({ index, license, deactivateLicense, activateLicense }) => {    
    const changeDateTimeFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        };
        return date.toLocaleDateString('en-us', options);
    }
    return (
        <>
            <tr className={styles.trLicenses} key={index}>
                <td className={styles.tdLicenses}> {license.exhibitorId}({license.exhibitorRefNumber })</td>
                <td className={styles.tdLicenses}> {license.exhibitorName}</td>
                <td className={styles.tdLicenses}> {license.exhibitorEmail}</td>
                <td className={styles.tdLicenses}> {license.exhibitorLicenseKey}</td>
                <td className={styles.tdLicenses}> {license.isActive === true ? 'Yes' : 'No'}</td>
                <td className={styles.tdLicenses}> {changeDateTimeFormat(license.createdDate)}</td>
                <td className={styles.tdLicenses}> {changeDateTimeFormat(license.lastLoginDate)}</td>
                <td className={styles.tdLicenses}> {license.licenseCount}</td>
                <td className={styles.tdLicenses}> {license.maxAllowed}</td>
                <td className={styles.tdLicenses}>
                    {
                        license.exhibitorLicenseKey !== undefined && license.exhibitorLicenseKey !== '00000000-0000-0000-0000-000000000000' ? 
                            license.isActive === true ? 
                                <button className={styles.editButton} onClick={e => deactivateLicense(e)} id={index} title="Deactivate license.">
                                    Deactivate License
                                </button>
                                :
                                <button className={styles.editButton} onClick={e => activateLicense(e)} id={index} title="Activate license.">
                                    Activate License
                                    </button>
                            :
                            <>N/A</>
                    }
                </td>
            </tr>
        </>
    );
}

export default LicenseItem;
